import { render, staticRenderFns } from "./listRole.vue?vue&type=template&id=79d2d034"
import script from "./listRole.vue?vue&type=script&lang=js"
export * from "./listRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports